import React from "react";
import "../styles/About.css"; // or create About.css if you want separate styling
import { useNavigate } from "react-router-dom";
const About = () => {
    const navigate = useNavigate();
    const handleClick = () => {
     navigate("/contact"); // redirects to Contact page
    };
  return (
    <>
      {/* ✅ Hero Section */}
      <section
        className="hero"
        style={{
          background: "linear-gradient(135deg, #d32f2f 60%, #f55f5f)",
          color: "white",
          textAlign: "center",
          padding: "6rem 2rem",
          clipPath: "polygon(0 0, 100% 0, 100% 85%, 0 100%)",
        }}
      >
        <h2>About Spandan Blood Bank</h2>
        <p
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            fontWeight: 300,
          }}
        >
          Committed to safe and timely blood for patients in need. We serve
          hospitals across the region via donation camps, community drives, and
          a dedicated volunteer network.
        </p>
      </section>

      {/* ✅ Main Content */}
      <main
        className="container"
        style={{
          maxWidth: "1600px",
          margin: "-3.5rem auto 2rem",
          background: "#fff",
          borderRadius: "16px",
          padding: "2rem",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          textAlign: "left",
        }}
      >
        <div
          className="grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 320px",
            gap: "1.5rem",
          }}
        >
          {/* Left Content */}
          <div 
            style={{
          textAlign: "left",
        }}
          >
            
            <h3 style={{ color: "#d32f2f", fontWeight: 700 }}>Who we are</h3>
            <p style={{ fontWeight: 300, lineHeight: 1.7 }}>
             Spandan Blood Bank is committed to providing safe and timely blood to patients in need. Founded in 2024, we have served thousands of individuals, supporting hospitals across the region. Our dedicated team of volunteers and staff ensure every donation is handled with utmost care and professionalism.
            </p>

            <h3
              style={{
                color: "#d32f2f",
                fontWeight: 700,
                marginTop: "1.6rem",
              }}
            >
              Our Mission
            </h3>
            <p style={{ fontWeight: 300, lineHeight: 1.7 }}>
              To save lives by providing reliable, screened blood supplies —
              while promoting voluntary blood donation and safe transfusion
              practices.
            </p>

            <h3
              style={{
                color: "#d32f2f",
                fontWeight: 700,
                marginTop: "1.6rem",
              }}
            >
              How we work
            </h3>
            <ul style={{ lineHeight: 1.7 }}>
              <li>
                Regular blood donation camps at community centers and colleges.
              </li>
              <li>Strict donor screening and safety protocols.</li>
              <li>Coordination with local hospitals for urgent requests.</li>
            </ul>
          </div>

          {/* Right Sidebar */}
          <aside
            className="card"
            style={{
              background: "#f6f6f6",
              padding: "1rem",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(211,47,47,0.06)",
            }}
          >
            <div
              style={{
                fontWeight: 700,
                color: "#d32f2f",
                marginBottom: "10px",
              }}
            >
              Quick Facts
            </div>
            <div>
              <strong>Founded:</strong> 2024
            </div>
            <div>
              <strong>Volunteers:</strong> 50+
            </div>
            <div>
              <strong>Camps held:</strong> 100+
            </div>
            <hr
              style={{
                margin: "12px 0",
                border: "none",
                borderTop: "1px solid #e7e7e7",
              }}
            />
            <div style={{ fontWeight: 700, marginBottom: "8px" }}>Join Us</div>
            <div style={{ fontSize: ".95rem", color: "#444" }}>
              Become a donor or volunteer — help save lives. Click below to
              register.
            </div>
            <button
              style={{
                marginTop: "12px",
                padding: ".7rem 1rem",
                borderRadius: "10px",
                border: "none",
                background: "#d32f2f",
                color: "#fff",
                cursor: "pointer",
              }}
              onClick={handleClick}
            >
              Register Now
            </button>
          </aside>
        </div>

        {/* ✅ Team Section */}
        <h3
          style={{
            color: "#d32f2f",
            fontWeight: 700,
            marginTop: "2rem",
          }}
        >
          Our Team
        </h3>
        <div
          className="team-list"
          style={{ display: "flex", flexDirection: "column", gap: ".8rem" }}
        >
          <div
            className="card"
            style={{
              background: "#f6f6f6",
              padding: "1rem",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(211,47,47,0.06)",
            }}
          >
            <strong>Medical In-charge:</strong> Dr. Sanjay R. Shrivastava<br />
            <small style={{ color: "#666" }}>
              Responsible for donor screening and medical protocols
            </small>
          </div>

                    <div
            className="card"
            style={{
              background: "#f6f6f6",
              padding: "1rem",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(211,47,47,0.06)",
            }}
          >
            <strong>BTO:</strong> Dr. Abhishek S. Baravkar & Dr. Mangesh J. Khandave<br />
            <small style={{ color: "#666" }}>
              Responsible for donor screening and medical protocols
            </small>
          </div>

          

          <div
            className="card"
            style={{
              background: "#f6f6f6",
              padding: "1rem",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(211,47,47,0.06)",
            }}
          >
            <strong>Operations Lead:</strong> Mrs. Santosh Rokade<br />
            <small style={{ color: "#666" }}>
              Coordinates camps and logistics
            </small>
          </div>
        </div>
      </main>
    </>
  );
};

export default About;
